import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

function createAppointmentDatesQueryKey(dto) {
  return [
    QUERY_KEYS.appointments.dates,
    dto.appointmentType,
    dto.bookWithFirst,
    dto.clinicId,
    dto.customServicesDuration,
    dto.doubleBooking,
    dto.outsideScheduledHours,
    (dto.providerIds || []).join("-"),
    (dto.services || []).join("-"),
    dto.startDate,
    dto.appointmentId,
    dto.accountId,
    dto.additionalProviderId,
    dto.ignoreAdditionalProviderSchedule,
  ].filter(Boolean);
}

export function useAppointmentDatesQuery(dto, options = {}) {
  return useQuery(
    createAppointmentDatesQueryKey(dto),
    () =>
      http.post(HTTP_ENDPOINTS.appointments.getDates(), {
        appointment_type: dto.appointmentType,
        book_with_first: dto.bookWithFirst,
        clinic_id: dto.clinicId,
        custom_services_duration: dto.customServicesDuration,
        double_booking: dto.doubleBooking,
        outside_scheduled_hours: dto.outsideScheduledHours,
        provider_ids: dto.providerIds,
        services: dto.services,
        start_date: dto.startDate,
        appointment_id: dto.appointmentId,
        account_id: dto.accountId,
        additional_provider_id: dto.additionalProviderId,
        ignore_additional_schedule: dto.ignoreAdditionalProviderSchedule,
      }),
    options,
  );
}
